"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forceProcessPermissions = exports.savePermissionsFailure = exports.savePermissionsSuccess = exports.savePermissionsRequest = exports.updateNotifications = exports.updatePermission = exports.toggleNewFolderPermission = exports.toggleIncludeSubfolders = exports.setPermissions = exports.projectFolderPermissionsReset = exports.fetchProjectFolderPermissionsFailure = exports.fetchProjectFolderPermissionsSuccess = exports.fetchProjectFolderPermissionsRequest = exports.changeSearchString = exports.changeExpand = exports.collapseUserGroupRow = exports.clearState = exports.PropertiesActions = exports.FolderTreeActions = void 0;
const ActionTypes = require("../../actionTypes/project/permissions");
const _FolderTreeActions = require("../../modules/files/tree/actions");
const _PropertiesActions = require("../../modules/files/crud/actions");
exports.FolderTreeActions = _FolderTreeActions.default('permissions');
exports.PropertiesActions = _PropertiesActions.default('permissions');
const clearState = () => ({
    type: ActionTypes.CLEAR_STATE
});
exports.clearState = clearState;
const collapseUserGroupRow = (groups, isCollapsed) => ({
    type: ActionTypes.COLLAPSE_USER_GROUP_ROW,
    payload: {
        groups,
        isCollapsed
    }
});
exports.collapseUserGroupRow = collapseUserGroupRow;
//#region Folder Selection
const changeExpand = (expand, folderIdentifier) => ({
    type: ActionTypes.CHANGE_EXPAND,
    payload: {
        expand,
        folderIdentifier
    }
});
exports.changeExpand = changeExpand;
//#endregion
//#region Folder Permissions
const changeSearchString = (searchString) => ({
    type: ActionTypes.CHANGE_SEARCH_STRING,
    payload: searchString
});
exports.changeSearchString = changeSearchString;
const fetchProjectFolderPermissionsRequest = (projectId, folderIdentifier) => ({
    type: ActionTypes.FETCH_PROJECT_FOLDER_PERMISSIONS_REQUEST,
    payload: {
        projectId,
        folderIdentifier
    }
});
exports.fetchProjectFolderPermissionsRequest = fetchProjectFolderPermissionsRequest;
const fetchProjectFolderPermissionsSuccess = (list) => ({
    type: ActionTypes.FETCH_PROJECT_FOLDER_PERMISSIONS_SUCCESS,
    payload: list
});
exports.fetchProjectFolderPermissionsSuccess = fetchProjectFolderPermissionsSuccess;
function fetchProjectFolderPermissionsFailure(error) {
    return {
        type: ActionTypes.FETCH_PROJECT_FOLDER_PERMISSIONS_FAILURE,
        payload: error
    };
}
exports.fetchProjectFolderPermissionsFailure = fetchProjectFolderPermissionsFailure;
const projectFolderPermissionsReset = () => ({
    type: ActionTypes.PROJECT_FOLDER_PERMISSIONS_RESET
});
exports.projectFolderPermissionsReset = projectFolderPermissionsReset;
const setPermissions = (processed) => ({
    type: ActionTypes.SET_PERMISSIONS,
    payload: processed
});
exports.setPermissions = setPermissions;
const toggleIncludeSubfolders = () => ({
    type: ActionTypes.TOGGLE_INCLUDE_SUBFOLDERS
});
exports.toggleIncludeSubfolders = toggleIncludeSubfolders;
const toggleNewFolderPermission = (groups, folder, status) => ({
    type: ActionTypes.TOGGLE_NEW_FOLDER_PERMISSION,
    payload: {
        groups,
        folder,
        status
    }
});
exports.toggleNewFolderPermission = toggleNewFolderPermission;
const updatePermission = (groups, folder, permission, newFolder, status) => ({
    type: ActionTypes.UPDATE_PERMISSION,
    payload: {
        folder,
        groups,
        permission,
        newFolder,
        status
    }
});
exports.updatePermission = updatePermission;
//#endregion
//#region Folder Create Edit
const updateNotifications = (folderIdentifier, folders, status, target, groupId) => ({
    type: ActionTypes.UPDATE_NOTIFICATIONS,
    payload: {
        folderIdentifier,
        folders,
        status,
        target,
        groupId
    }
});
exports.updateNotifications = updateNotifications;
//#endregion
const savePermissionsRequest = () => ({
    type: ActionTypes.SAVE_PERMISSIONS_REQUEST
});
exports.savePermissionsRequest = savePermissionsRequest;
const savePermissionsSuccess = () => ({
    type: ActionTypes.SAVE_PERMISSIONS_SUCCESS
});
exports.savePermissionsSuccess = savePermissionsSuccess;
const savePermissionsFailure = (error) => ({
    type: ActionTypes.SAVE_PERMISSIONS_FAILURE,
    payload: error
});
exports.savePermissionsFailure = savePermissionsFailure;
const forceProcessPermissions = () => ({
    type: ActionTypes.FORCE_PROCESS_PERMISSIONS
});
exports.forceProcessPermissions = forceProcessPermissions;
//# sourceMappingURL=permissions.js.map